module.exports = __webpack_public_path__ + "static/media/kppg.f6f809ba.gif";